export const TECH_RADIUS_DESKTOP = 125;
export const TECH_RADIUS_MOBILE = 100;
export const TOOLS_RADIUS_DESKTOP = 100;
export const TOOLS_RADIUS_MOBILE = 80;
